import axios from 'axios'
import {Response} from '@/domain/Common'
import env from '@/util/Env'

export type RankingType = 'Profit' | 'Popularity' | 'Esg'

export class PortfolioRankingService {
  public static async getRanking(rankingType: RankingType)
    : Promise<PortfolioRanking> {
    return axios
      .get<Response<PortfolioRanking>>(
        `${env.ApiUrl}/public/portfolio/ranking?type=${rankingType}`,
      )
      .then((res) => {
        return res.data.result
      })
  }
}

export interface PortfolioRanking {
  portfolios: PortfolioRankingData[]
}

export interface PortfolioRankingData {
  portfolio: {
    code: string,
    description: string,
    descriptionShort: string,
    esgRank: number,
    esgScore: string,
    esgScoreE: string,
    esgScoreG: string,
    esgScoreS: string,
    name: string,
    performance: { performance1y: string },
    popularityRank: number,
    profitRank: number,
    risk: string,
    strength: string,
  }
}
